import { FC, useMemo } from "react";
import { python } from "@codemirror/lang-python";
import type { Completion } from "@codemirror/autocomplete";

import BasicEditor from "../BasicEditor";
import { mentionVariables } from "../BasicEditor/extensions";

export interface PythonEditorProps {
  value?: string;
  onChange: (v: string) => void;
  variables: { label: string; key: string }[];
}

// Python 编辑器
const PythonEditor: FC<PythonEditorProps> = ({
  onChange,
  variables,
  value,
}) => {
  const completions = useMemo<Completion[]>(
    () =>
      variables.map((v) => ({
        label: `${v.key}`,
        displayLabel: v.label,
        type: "variable",
      })),
    // 用内容签名做依赖，避免父组件每次渲染传入新数组引用
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [variables.map((v) => `${v.key}:${v.label}`).join("|")]
  );

  const extensions = useMemo(
    () => [mentionVariables(completions), python()],
    [completions]
  );

  return (
    <BasicEditor
      value={value ?? ""}
      onChange={onChange}
      language="python"
      extensions={extensions}
    />
  );
};

export default PythonEditor;
